<!-- * HEADER -->
<nz-page-header class="px-0 py-0" nzBackIcon>
    <nz-page-header-title class="font-semibold text-base">{{config.formName | titlecase}}</nz-page-header-title>
</nz-page-header>
<nz-divider class="my-4"></nz-divider>
<form nz-form [nzLayout]="'vertical'" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div nz-row nzGutter="16">
        <div nz-col class="gutter-row mb-4" 
             [nzXs]="field.type === 'file' ? 24 : 24" 
             [nzMd]="field.type === 'file' ? 24 : 8" 
             [nzLg]="field.type === 'file' ? 24 : 8" 
             [nzXl]="field.type === 'file' ? 24 : 6" 
             *ngFor="let field of config.fields">
            <nz-form-item class="m-0">
                <nz-form-label [nzRequired]="hasValidatorType(field, 'required')" [nzForControl]="field.name">{{ field.label }}</nz-form-label>
                <nz-form-control [ngSwitch]="field.type" [nzErrorTip]="validationErrorTemplate">

                    <!-- Text Input -->
                    <input *ngSwitchCase="'text'" nz-input [formControlName]="field.name" [id]="field.name"
                        [type]="'text'" [placeholder]="field.placeholder" [minlength]="3" [maxlength]="100" [class]="field.customAttributes?.class"
                        [attr]="getCustomAttributes(field.customAttributes)"
                        class="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        (ngModelChange)="field.onChangeMethod?.($event)" />

                    <!-- Email Input -->
                    <input *ngSwitchCase="'email'" nz-input [formControlName]="field.name" [id]="field.name"
                        [type]="'email'" [placeholder]="field.placeholder" [minlength]="3" [maxlength]="100" [class]="field.customAttributes?.class"
                        [attr]="getCustomAttributes(field.customAttributes)"
                        class="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        (ngModelChange)="field.onChangeMethod?.($event)" />

                    <!-- Text Area -->
                    <textarea *ngSwitchCase="'textarea'" [formControlName]="field.name" [id]="field.name"
                        [placeholder]="field.placeholder" [minlength]="3" [maxlength]="200" [attr]="getCustomAttributes(field.customAttributes)"
                        class="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        (ngModelChange)="field.onChangeMethod?.($event)"></textarea>

                    <!-- Single Select -->
                    <nz-select *ngSwitchCase="'select'" class="mt-1 w-full" [formControlName]="field.name"
                        [id]="field.name" [nzPlaceHolder]="field.placeholder || 'Select'" [nzShowSearch]="true">
                        <nz-option *ngFor="let option of field.options" [nzValue]="option.nzValue"
                            [nzLabel]="option.nzLabel">
                        </nz-option>
                    </nz-select>

                    <!-- Grouped Select -->
                    <nz-select *ngSwitchCase="'select-group'" class="mt-1 w-full" [formControlName]="field.name"
                        [id]="field.name" [nzPlaceHolder]="field.placeholder || 'Select'" [nzShowSearch]="true">
                        <nz-option-group *ngFor="let group of field.groupedOptions | keyvalue" [nzLabel]="group.key">
                            <nz-option *ngFor="let option of group.value"
                                [nzValue]="option.nzValue" [nzLabel]="option.nzLabel"
                                [nzDisabled]="option.nzDisabled || false">
                            </nz-option>
                        </nz-option-group>
                    </nz-select>

                    <!-- Multi Select -->
                    <ng-template #customRemoveIcon>
                        <!-- <i nz-icon nzType="delete"></i> -->
                    </ng-template>
                    <nz-select *ngSwitchCase="'multiselect'" class="mt-1 w-full"
                        [nzRemoveIcon]="field.name === 'capabilities' ? customRemoveIcon : null"
                        [formControlName]="field.name" [nzMaxTagCount]="2" [id]="field.name" [nzShowSearch]="true"
                        [nzPlaceHolder]="field.placeholder || 'Select'" nzMode="multiple">
                        <nz-option *ngFor="let option of field['options']" [nzDisabled]="option?.nzDisabled" [nzValue]="option.nzValue"
                            [nzLabel]="option.nzLabel"></nz-option>
                    </nz-select>

                    <!-- Checkbox -->
                    <div *ngSwitchCase="'checkbox'" class="flex flex-col gap-2">
                        <nz-form-label class="inline-flex items-center" [ngClass]="{'no-padding' : isGatewayForm}">
                            <input nz-input type="checkbox" [formControlName]="field.name" [id]="field.name"
                                [attr]="getCustomAttributes(field.customAttributes)" class="form-checkbox h-5 w-5 mr-2"
                                (ngModelChange)="field.onChangeMethod?.($event)" />
                            {{field.subLabel}}
                        </nz-form-label>
                        <!-- Extra input field for Gateway forms -->
                        <div *ngIf="isGatewayForm && field.type === 'checkbox'">
                            <input nz-input formControlName="severity" placeholder="Enter severity"
                                class="mt-1 block w-full border-gray-300 rounded-md shadow-sm sm:text-sm" />
                        </div>
                    </div>
                    <!-- Conatct -->
                    <nz-input-group *ngSwitchCase="'contact'" class="flex items-start">
                        <nz-select nz-input nzShowSearch name="countryCode" id="countryCode" formControlName="countryCode" style="width: 40%;">
                            <nz-option [nzValue]="country.code + '|' + country.country" [nzLabel]="'(' + country.code + ') ' + country.country" *ngFor="let country of countryCodes$"></nz-option>
                        </nz-select>
                        <nz-form-control [nzErrorTip]="contactError" class="w-[70%]">
                            <input [maxlength]="field.validators?.[3]?.value || null" [minlength]="field.validators?.[2]?.value || null"
                                nz-input OnlyNumber [formControlName]="field.name" [id]="field.name" type="text"
                                [placeholder]="field.placeholder || ''" class="w-full" />
                        </nz-form-control>
                        <ng-template #contactError let-control>
                            @if(control.errors?.['required']){<span>Phone number is required</span>}
                            @if(control.errors?.['minlength']){<span>Phone number must be at least 10 digits</span>}
                        </ng-template>
                    </nz-input-group>

                    <div *ngSwitchCase="'file'" class="mt-1">
                        <nz-upload
                            nzType="drag"
                            [nzMultiple]="true"
                            [nzBeforeUpload]="getFileUploadHandler(field.name, field.fileLimit)"
                            [(nzFileList)]="fileLists[field.name]"
                            [nzShowUploadList]="{ showPreviewIcon: true, showRemoveIcon: true, showDownloadIcon: true }"
                            [nzAccept]="field.customAttributes?.['accept'] || '.pdf,.jpeg,.jpg,.png,.mp4'"
                            [nzRemove]="getFileRemoveHandler(field.name)"
                            [nzPreview]="getFilePreviewHandler()"
                            [nzDownload]="getFileDownloadHandler()">
                            <div class="text-center py-5">
                                <i nz-icon nzType="cloud-upload" nzTheme="outline" class="text-5xl text-blue-400 mb-2"></i>
                                <div class="font-medium text-gray-800 mb-1">Click or drag file(s) to this area to upload</div>
                                <p class="text-xs text-gray-500">{{ field.placeholder || 'PDF, JPG, PNG, MP4 are supported' }}</p>
                            </div>
                        </nz-upload>
                    </div>
                </nz-form-control>

                <!-- Validation Messages -->
                <ng-template #validationErrorTemplate let-control>
                    <ng-container *ngFor="let validator of field.validators">
                        @if(control.errors?.[validator.type]){<span>{{ validator.message }}</span>}
                    </ng-container>
                </ng-template>
            </nz-form-item>
        </div>
    </div>
    <nz-divider class="my-4"></nz-divider>
    <!--  Buttons Section-->
    <div class="flex flex-row flex-nowrap justify-end">
        <button nz-button type="button" *ngIf="config.formType === 'create'"
            class="bg-gray-300 text-black py-1 px-6 rounded-md shadow-sm mr-2 hover:bg-secondary-hover" nz-popconfirm
            nzPopconfirmPlacement="bottom" (nzOnConfirm)="resetForm()" [disabled]="!formGroup.touched || formGroup.pristine"
            nzPopconfirmTitle="Are you sure you want to reset this form?">
            Reset
        </button>
        <button *ngIf="!isMultirecord" nz-button type="button"
            class="bg-primary text-white py-1 px-6 rounded-md shadow-sm hover:bg-secondary-hover"
             nz-popconfirm
            [nzPopconfirmTitle]="'Are you sure you want to ' + (config.formType === 'create' ? 'submit' : 'update') + ' this record?'"
            nzPopconfirmPlacement="bottom" (nzOnConfirm)="onSubmit()">
            {{ config.formType === 'create' ? 'Submit' : 'Update' }}
        </button>
    </div>
</form>